import React, { useEffect, useState } from 'react'
import AdminHeader from '../AdminHeader'
import './AdminOrderDS.css'
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select';
import { Autocomplete, TextField } from '@mui/material'
import { CustomerFindAll, EmployeeFindAll, EmployeeToCustomerAdd, EmployeeToCustomerDelete, EmployeeToCustomerFindAll, EmployeeToCustomerUpdate } from '../../API/Api'

const OrderBoyToCusAllotment = () => {

  const [isEditing, setisEditing] = useState(false)
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [eTocId, seteTocId] = useState()
  const [employee_master, setEmployee_master] = useState([]);
  const [customer_master, setCustomer_master] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [customerId, setCustomerId] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEdit, setShowEdit] = useState(false);

  // =========== delete modal =========
 const [show1, setShow1] = useState(false);
 const handleClose1 = () => setShow1(false);

 const [itemToDelete, setItemToDelete] = useState(null);

 const handleShow1 = (item) => {
   setItemToDelete(item);
   setShow1(true);
 };  

 const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const branchId = userdata.branch_id;

//  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    seteTocId('');
    setEmployeeId('');
    setCustomerId('');
  };

  const handleEditShow = (item) => {
    setEmployeeId(item.employee_id);
    setCustomerId(item.customer_id);
    seteTocId(item.id );
    setShowEdit(true);
  };

  // const updateEmpToCustomer = () => {
  //   if (!customerId || !employeeId) {
  //     alert("Please select both customer and employee");
  //     return;
  //  }
  //   const formData = {
  //     employee_id : employeeId ,
  //     eTocId : eTocId,
  //     customer_id : customerId
  //   };
  //   console.log("response",formData);
  //   axios
  //     .put(`${EmployeeToCustomerUpdate}${eTocId}`, formData)
  //     .then((res) => {
  //       if (res.data === "UPDATE") {
          
  //         toast.success("Data Updated Successfully!", {
  //           position: "top-right",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         });
  //         Getdata();
  //         handleEditClose();
  //       }else if( res.data === "ALREADYEXIST"){
  //         toast.info("Data already exists.", {
  //           position: "top-right",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         });
  //         setEmployeeId('');
  //         setCustomerId('');
  //       }
  //     })
  //     .catch((err) => {
  //       // Add debugging information to identify the issue
  //       console.error("Error while updating Employee:", err);
  //       if (err.response) {
  //         console.error("Response data:", err.response.data);
  //       }
  
  //       toast.error("Failed to update data, please try again", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //       });
  //     });
  // };


const savedata = (e) => {
    e.preventDefault();
  
    if (!customerId || !employeeId) {
      alert("Please select both customer and employee");
      return;
   }
  
    const obj ={
      employee_id : employeeId,
      customer_id : customerId,
      branch_id : branchId
    }
    console.log("FormData",obj)
  
    axios
      .post(EmployeeToCustomerAdd, obj)
      .then((res) => {
        
        if (res.data === "SAVED") {
          console.log("res.data",res.data)
          toast.success("Data Saved Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          // Reset form fields and reload the data
          Getdata();
          setEmployeeId('');
          setCustomerId('');
          seteTocId('');
          setShow(false);
          // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
        } else if( res.data === "ALREADYEXIST"){
          toast.info("Already assign to other employee...", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setEmployeeId('');
          setCustomerId('');
        }
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.error(err);
      });
  };

     //Getdata Logic
     const Getdata = (e) => {
      console.log("api...",`${EmployeeToCustomerFindAll}/${branchId}`);
      axios  
        .get(`${EmployeeToCustomerFindAll}/${branchId}`)
        .then((res) => {
          console.log("findallllllllll",res.data)
          if (res.data !== null) {
            setData(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
  useEffect(() => {
    Getdata();
  }, [])
  
  
  
  
    //delete data
    const onDelete = (item) => {
      console.log("Deleting item:", item);
      axios  
        .delete(`${EmployeeToCustomerDelete}${item.id}`)
        .then((res) => {
          console.log("Delete response:", res.data);
          if (res.data === "DELETE") {
            // alert("File Deleted Succesfully");
            toast.success("Data Deleted Succesfuly!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
          handleClose1(false)
          Getdata();
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          console.log("Error deleting item:", err);
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
     //CustomerData Logic
 const Customerdata = (e) => {
  axios  
.get(`${CustomerFindAll}/${branchId}`)
    .then((res) => {
      if (res.data !== null) {
        setCustomer_master(res.data);
      }
      setisEditing(false);
    })
    .catch((err) => {
      // alert("Failed to upload, try again");
      toast.error("Failed to upload, try again", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      console.log(err);
    });
};


   //Employeedata Logic
 const Employeedata = (e) => {
  axios  
    .get(`${EmployeeFindAll}/${branchId}`)
    .then((res) => {
      if (res.data !== null) {
        setEmployee_master(res.data);
      }
      setisEditing(false);
    })
    .catch((err) => {
      // alert("Failed to upload, try again");
      toast.error("Failed to upload, try again", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      console.log(err);
    });
};
useEffect(() => {
  if (isEditing === false) {
    Getdata();
    Employeedata();
    Customerdata();

  }
}, [isEditing]);

 //HEADING FONT ===================

 const headingStyle = {
  fontSize: '27px',
  fontWeight: 'bold',
  textAlign: 'center',
};

const subheadingStyle = {
  color: 'rgb(255, 93, 0)', // Assuming this is the color for "text-violet-800"
  fontWeight: 300, // Assuming this is the font weight for "font-[300]"
  textShadow:"3px 1px 5px rgb(180, 180, 180)",
};

  return (
    <Container fluid>
        <Row> <AdminHeader /> </Row>

        <Row  className='BgImg px-md-5'>

 {/* ====================== table =============== */}
 <Row className='m-0 p-0  px-md-5  py-1 mb-5  w-100' style={{display:"flex"}}>
   <Row className='pt-3'>
    {/* <Col style={{color:"white",display:"flex",justifyContent:"center",marginTop:"-23px"}}>
    <h4>Employee To Customer Allotment</h4>
    </Col> */}
    <div className="heading text-black pt-3 pt-2 pt-md-3 mt-2 mt-md-1 mb-2" style={headingStyle}>
      <span style={subheadingStyle}>Employee To Customer</span> Allotment
      </div>
   </Row>
   <div  style={{display:"flex"}}>
    <button className='p-1 px-2' onClick={handleShow}  style={{backgroundColor:"papayawhip",border:"2px solid darkslategray",borderTopRightRadius:"15px"}}><b >ADD</b></button>
   </div>

   <div style={{ overflowY: 'auto'}}>
  <div style={{ overflowX: 'auto' }}>
     <Table striped bordered hover size="sm" className='shadow mb-5 mt-2' style={{textAlign:"center"}}>
         <thead >
             <tr > 
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Sr.No</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Customer</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Employee</th>
                 {/* <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Edit</th> */}
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Delete</th>
             </tr>
         </thead>
         <tbody>
           {data.map((item,index)=>{
             return(               
             <tr className='border' >
                 <td style={{ textAlign:"center"}}>{index+1}</td>
                 <td style={{ textAlign:"center"}}>{item.customer_name}</td>
                 <td style={{ textAlign:"center"}}>{item.name}</td>
                 {/* <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"orange",border:"0px", backgroundColor:"transparent"}}
                  onClick={() => handleEditShow(item)}
                ><i class="fa-solid fa-pen-to-square"></i></button></td> */}
                <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"red",border:"0px", backgroundColor:"transparent"}}
                
                onClick={() => handleShow1(item)}
                 ><i className="fa-solid fa-trash"></i></button></td>
             </tr>
              )
             })} 
         </tbody>
     </Table>
     </div>
     </div>
   </Row>

{/* ========================== Modal ============= */}
<Modal className='shadow rounded' show={show} onHide={handleClose}>
    <Modal.Header className='m-0 p-0 ps-3 text-center' style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
      <Modal.Title >
  <p style={{fontSize:"20px"}} className='text-center mt-2'><b>Employee To Customer Allotment</b></p>
  </Modal.Title>
</Modal.Header>

<Modal.Body>
<Form encType="multipart/form-data">
<Row className='m-0'>
     <Col sm={12} md={12} className='mt-3'>
  <Form.Label><h6><b>Customer :</b></h6></Form.Label>
  <Autocomplete
    disablePortal
    style={{ width: '100%' }}
    id="combo-box-demo"
    size="small"
    options={customer_master}
    getOptionLabel={(option) => option.customer_name} // Assuming customer_name is the label
    value={customer_master.find((item) => item.customer_id === customerId) || null}
    onChange={(e, newValue) => setCustomerId(newValue ? newValue.customer_id : '')}
    renderInput={(params) => <TextField {...params} label="Select Customer" />}
  />
</Col>

     <Col sm={12} md={12} className='mt-3 mb-3'>
      <Form.Label><h6 ><b>Employee :</b></h6></Form.Label>
      <Autocomplete
    disablePortal
    size="small"
    id="combo-box-demo"
    style={{ width: '100%' }}
    options={employee_master}
    getOptionLabel={(option) => option.name} 
    value={employee_master.find((item) => item.employee_id === employeeId) || null}
    onChange={(e, newValue) => setEmployeeId(newValue ? newValue.employee_id : '')}
    renderInput={(params) => <TextField {...params} label="Select Employee" />}
  />
     </Col>

   </Row>
  </Form>
</Modal.Body>

<Modal.Footer className='m-0 p-0' style={{backgroundColor:"rgb(214, 234, 248)"}}>
  <Button style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}} onClick={handleClose}>
    Cancel
  </Button>
  <Button style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' type='submit' onClick={savedata}>
    Save 
  </Button>
</Modal.Footer>
</Modal>

{/* =================== Edit Modal ======================== */}
 
<Modal show={showEdit} onHide={handleEditClose}>
      <Modal.Header className='m-0 p-0 ps-3 text-center' style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
      <Modal.Title >
      <p style={{fontSize:"20px"}} className='text-center mt-2'><b>Employee To Customer Allotment</b></p>
      </Modal.Title>
    </Modal.Header>


    <Modal.Body>
<Form encType="multipart/form-data">
<Row className='m-0'>
     <Col sm={12} md={12} className='mt-3'>
  <Form.Label><h6><b>Customer :</b></h6></Form.Label>
  <Autocomplete
    disablePortal
    id="combo-box-demo"
    size="small"
    options={customer_master}
    getOptionLabel={(option) => option.customer_name} // Assuming customer_name is the label
    value={customer_master.find((item) => item.customer_id === customerId) || null}
    onChange={(e, newValue) => setCustomerId(newValue ? newValue.customer_id : '')}
    renderInput={(params) => <TextField {...params} label="Select Customer" />}
  />
</Col>

     <Col sm={12} md={12} className='mt-3 mb-3'>
      <Form.Label><h6 ><b>Employee :</b></h6></Form.Label>
      <Autocomplete
    disablePortal
    id="combo-box-demo"
    size="small"
    options={employee_master}
    getOptionLabel={(option) => option.name} 
    value={employee_master.find((item) => item.employee_id === employeeId) || null}
    onChange={(e, newValue) => setEmployeeId(newValue ? newValue.employee_id : '')}
    renderInput={(params) => <TextField {...params} label="Select Employee" />}
  />
     </Col>

   </Row>
  </Form>
</Modal.Body>

    <Modal.Footer className='m-0 p-0' style={{backgroundColor:"rgb(214, 234, 248)"}}>
      <Button style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}} onClick={handleEditClose}>
        Cancel
      </Button>

          {/* <Button style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => updateEmpToCustomer(eTocId,employeeId,customerId)}>
            Update
          </Button> */}
        </Modal.Footer>
      </Modal>

        {/* ============= Delete Modal ========= */}

        <Modal show={show1} onHide={handleClose1}>
        <Modal.Header style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
          <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i>  Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to delete this item?</Modal.Body>
          <p className='text-end'>
          <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}}  onClick={handleClose1}>
            Cancel
          </Button>
          <Button  style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
            Delete
          </Button></p>
      </Modal>

</Row>

    </Container>
  )
}

export default OrderBoyToCusAllotment